import { all, fork } from 'redux-saga/effects';
import { watchFeatureFlagSaga } from './feature-flag';
import { watchQueryClientSaga } from './query-client';

export const coreRootSaga = function* () {
  yield all([fork(watchQueryClientSaga), fork(watchFeatureFlagSaga)]);
};
